var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationScribbleCurveArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 324.4 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11.2 81.8c-2.7 11.8-5.4 23.5-8 35.3-.1.5-.2 1-.1 1.5.3 1.2 2 1.3 3.2 1.2 14.2-1.8 28.6-2.5 42.8-2.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M249.9 147.8c21.3-12.2 42.4-25.9 57.5-45.1 8.6-10.8 15.2-24 14-37.8-1.7-19-17.9-33.6-34.7-42.8-47.7-26-107.4-24-157.7-3.4C78.9 39.5 37.2 77 3 118.9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationScribbleCurveArrow);
export default __webpack_public_path__ + "static/media/illustration-scribble-curve-arrow.fa52f0f031a4af017b31241b2c6295e4.svg";
export { ForwardRef as ReactComponent };